"use client";

import React from "react";
import { Quote, CircleCheck } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "James P.",
  quote: "The roofing team from Protech was incredibly precise. Our new slate roof looks architectural and feels impenetrable. Truly professional work.",
  position: "Homeowner • Roofing & Gutters"
}, {
  id: 2,
  author: "Sarah L.",
  quote: "They transformed our curb appeal with high-efficiency windows and modern siding. The attention to detail in the framing was impressive.",
  position: "Architect • Siding & Windows"
}, {
  id: 3,
  author: "Robert M.",
  quote: "Protech built a custom deck that has become our favorite part of the house. The craftsmanship is durable and the finish is flawless.",
  position: "Property Owner • Custom Decking"
}];
export default function StimmenUnsererKunden() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222594" id="voice-of-the-neighborhood" className="w-full py-24 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`transition-all duration-1000 ease-out flex flex-col items-center ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12 md:mb-16 max-w-2xl mx-auto">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter text-foreground mb-4 uppercase">
              Voice of the Neighborhood
            </h2>
            <p className="font-default text-muted-foreground text-lg">
              See why homeowners trust Protech Restoration for their most critical exterior improvements and architectural protection.
            </p>
          </div>

          <div className="w-full max-w-5xl mx-auto relative">
            {}
            <div className="absolute inset-0 bg-muted/30 border border-border/50 rounded-sm -z-10 transform -rotate-1 scale-105 transition-transform duration-500 hover:rotate-0" />
            
            <div className="bg-muted/40 backdrop-blur-sm border border-border/50 rounded-sm p-8 md:p-16 lg:p-20 relative">
              <Quote className="absolute top-8 left-8 md:top-12 md:left-12 size-16 md:size-24 text-primary/10 -z-0" />
              
              <Carousel opts={{
              align: "start",
              loop: true
            }} className="w-full relative z-10">
                <CarouselContent>
                  {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                      <div className="flex flex-col items-center text-center space-y-8 md:space-y-12">
                        <blockquote className="max-w-3xl">
                          <p className="font-default italic text-2xl md:text-3xl lg:text-4xl leading-tight text-foreground/90 font-semibold tracking-tight">
                            "{testimonial.quote}"
                          </p>
                        </blockquote>
                        
                        <div className="flex flex-col items-center space-y-4">
                          <div className="space-y-1">
                            <h3 className="font-default text-xl font-bold text-foreground">
                              {testimonial.author}
                            </h3>
                            <p className="text-muted-foreground text-sm font-mono uppercase tracking-wider">
                              {testimonial.position}
                            </p>
                          </div>
                          
                          <Badge variant="secondary" className="bg-primary text-primary-foreground border-none gap-1.5 py-1 px-3 rounded-sm font-mono text-xs">
                            <CircleCheck className="size-3.5" />
                            Certified Restoration
                          </Badge>
                        </div>
                      </div>
                    </CarouselItem>)}
                </CarouselContent>
                
                <div className="hidden md:block">
                  <CarouselPrevious className="bg-background/80 hover:bg-primary hover:text-primary-foreground border-border text-foreground rounded-sm transition-colors" />
                  <CarouselNext className="bg-background/80 hover:bg-primary hover:text-primary-foreground border-border text-foreground rounded-sm transition-colors" />
                </div>
                
                {}
                <div className="flex justify-center gap-2 mt-8 md:hidden">
                  <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background/80 border-border text-foreground rounded-sm" />
                  <CarouselNext className="static translate-y-0 translate-x-0 bg-background/80 border-border text-foreground rounded-sm" />
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </section>;
}